import { getCountryCode } from '@gameday/common/functions'
import { teamConditionalQuestions } from 'constants/common'
import { compact, get } from 'lodash'

import { getTeamsByUser } from './teams'

export const getFormInfo = state => get(state, 'formInfo')

export const getFormDbId = state => get(state, 'formInfo.form.id')

export const getEventId = state => get(state, 'formInfo.event.id')

export const getIsTeamEvent = state => get(state, 'formInfo.event.isTeamEvent')

export const getEventTeamLimit = state => get(state, 'formInfo.event.eventTeamLimit', null)

export const getMemberTypes = state => get(getFormInfo(state), 'memberTypes')

export const getFormProducts = state => get(getFormInfo(state), 'products')

export const getFormAddOnProducts = state => get(getFormInfo(state), 'addOn.products')

export const getFormDiscounts = state => get(getFormInfo(state), 'discounts')

export const getDefaultQuestions = state => get(getFormInfo(state), 'defaultQuestions')

export const getDefaultTeamQuestions = state => [
  ...teamConditionalQuestions(getTeamsByUser(state)),
  ...get(getFormInfo(state), 'defaultTeamQuestions'),
]

export const getQuestions = state => get(getFormInfo(state), 'questions')

export const getCountry = state => get(getFormInfo(state), 'organisation.country')

export const getHierarchyCountryCode = state => {
  const orgCountry = get(getFormInfo(state), 'organisation.country.countryCode')
  if (orgCountry) return orgCountry

  const billingCountry = get(state, 'formSettings.organisation.billingCountry')
  if (billingCountry) {
    return getCountryCode(billingCountry)
  }

  return null
}

export const getFormValidationRule = state => get(getFormInfo(state), 'form.displayRules')

export const getFormAgeRestriction = state => get(getFormInfo(state), 'ageRestriction')

export const getOrgTimezones = state => {
  const orgInfo = get(getFormInfo(state), 'organisationsInfo') || []
  // biome-ignore lint/performance/noAccumulatingSpread: TODO
  return orgInfo.reduce((a, o) => ({ ...a, [o.sfid]: o.timezone }), {})
}

export const getOrgCurrency = state => get(getFormInfo(state), 'organisation.currencyCode') || []

export const getOrgSfid = state => get(getFormInfo(state), 'organisation.sfid') || []

export const getOrgAddress = storeState => {
  const { organisation } = getFormInfo(storeState) || {}

  const city = get(organisation, 'city', '')
  const state = get(organisation, 'state', '')
  const postalCode = get(organisation, 'postalCode', '')
  const country = get(organisation, 'country.name', '')

  return {
    city,
    state,
    postalCode,
    country,
  }
}
export const getRoktConfiguration = state => {
  const {
    organisation: { enableRoktMembershipForm, enableRoktEventForm, enableRoktShopForm },
  } = getFormInfo(state) || {}
  return {
    enableRoktMembershipForm,
    enableRoktEventForm,
    enableRoktShopForm,
  }
}
export const getFormMessages = state => {
  const messages = get(getFormInfo(state), 'messages') || []
  const orgs = get(getFormInfo(state), 'organisationsInfo') || []
  // biome-ignore lint/performance/noAccumulatingSpread: TODO
  const orgMap = orgs.reduce((a, o) => ({ ...a, [o.sfid]: o }), {})

  const welcome = []
  const confirmation = []
  const teamWelcome = []
  const teamSuccess = []
  messages.forEach(m => {
    const org = orgMap[m.definedBy] || {}

    if (m.welcomeMessage) {
      welcome[org.financialLevel || 0] = {
        message: m.welcomeMessage,
        subText: org.name,
      }
    }
    if (m.confirmationMessage) {
      confirmation[org.financialLevel || 0] = {
        message: m.confirmationMessage,
        subText: org.name,
      }
    }
    if (m.teamWelcomeMessage) {
      teamWelcome[org.financialLevel || 0] = {
        message: m.teamWelcomeMessage,
        subText: org.name,
      }
    }
    if (m.teamSuccessMessage) {
      teamSuccess[org.financialLevel || 0] = {
        message: m.teamSuccessMessage,
        subText: org.name,
      }
    }
  })
  return {
    welcome: compact(welcome),
    confirmation: compact(confirmation),
    teamWelcome: compact(teamWelcome),
    teamSuccess: compact(teamSuccess),
  }
}
export const getDisplayPriceAsZero = state => get(getFormInfo(state), 'form.displayPriceAsZero')

export const getFeeConfigurations = state => {
  const feeConfigurations = []
  get(getFormInfo(state), 'organisationsInfo').forEach(org => {
    org.feeConfigurations.forEach(feeConfig => {
      feeConfigurations.push({
        organisation: org.sfid,
        minimumTransactionAmount: feeConfig.minimumTransactionAmount,
        maximumTransactionAmount: feeConfig.maximumTransactionAmount,
        fee: feeConfig.fee,
        feeAmount: feeConfig.feeAmount,
        feePCAmount: feeConfig.feePCAmount,
        feeTax: feeConfig.feeTax,
        surcharge: feeConfig.surcharge,
        paymentGateway: feeConfig.paymentGateway,
      })
    })
  })

  return feeConfigurations
}
